import { BusinessContact } from '@40seas/entities/businesses';
import { Omit, Replace } from '@40seas/entities/common';
import { z } from 'zod';

export class CreateBusinessContactDto extends Replace(Omit(BusinessContact, ['id', 'fullName']), [
    {
        fieldName: 'ssn',
        newFieldSchema: z
            .string()
            .regex(/^(\d{3}-\d{2}-\d{4}|\d{9})$/, { message: 'must be in XXXXXXXXX or XXX-XX-XXXX format' })
            .nullish(),
    },
]) {}
